import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@shared';

@Injectable({ providedIn: 'root' })
export class OnboardingScreensService {
  constructor(private http: HttpClient) {}

  getOnboardingScreens() {
    return this.http.get<ApiResponse>('/v1/admin/onboarding-screens');
  }

  addOnboardingScreens(id: string | null, onboardingData: any) {
    return this.http.put<ApiResponse>(`/v1/admin/onboarding-screens/${id}`, onboardingData);
  }
}
